/* src/app/modules/taxes/model-182/model-182.component.css */
:host {
  --m182-brand: #e3fd64;
  --m182-brand-d: #4d7a00;
  --m182-brand-bg: rgba(227, 253, 100, 0.08);
  --m182-text: #1a1d23;
  --m182-muted: #6b7280;
  --m182-border: #e5e7eb;
  --m182-surface: #ffffff;
  --m182-radius: 10px;
  --m182-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.m182-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.m182-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.m182-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--m182-brand-bg);
  flex-shrink: 0;
}
.m182-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.m182-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--m182-text);
  line-height: 1.2;
}
.m182-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--m182-muted);
}
.m182-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.m182-actions__spacer {
  flex: 1 1 auto;
  min-width: 0;
}
.m182-alerts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m182-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(227, 253, 100, 0.1);
  border: 1px solid rgba(227, 253, 100, 0.4);
  border-left: 4px solid var(--m182-brand);
  border-radius: var(--m182-radius);
}
.m182-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.m182-alert__text {
  flex: 1 1 auto;
  font-size: 13px;
  color: var(--m182-text);
}
.m182-alert__link {
  font-size: 12px;
  font-weight: 600;
  color: var(--m182-brand-d);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
}
.m182-alert__link:hover {
  text-decoration: underline;
}
.m182-alert--warning {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}
.m182-fields {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 8px 12px;
  align-items: end;
}
.m182-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  grid-column: span 3;
}
.m182-field--2 {
  grid-column: span 2;
}
.m182-field--3 {
  grid-column: span 3;
}
.m182-field--4 {
  grid-column: span 4;
}
.m182-field--5 {
  grid-column: span 5;
}
.m182-field--6 {
  grid-column: span 6;
}
.m182-field--8 {
  grid-column: span 8;
}
.m182-field--9 {
  grid-column: span 9;
}
.m182-field--12 {
  grid-column: span 12;
}
.m182-field ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.m182-calc__label {
  font-size: 12.5px;
  color: var(--m182-muted);
}
.m182-input {
  width: 100%;
  min-width: 70px;
  height: 34px;
  padding: 6px 10px;
  border: 1px solid var(--m182-border);
  border-radius: 8px;
  font-size: 13px;
  text-align: right;
  color: var(--m182-text);
  background: #fff;
  box-sizing: border-box;
}
.m182-input:focus {
  outline: none;
  border-color: var(--m182-brand);
}
.m182-input--calc {
  background: #eceff1;
  font-weight: 600;
}
.m182-pill {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid var(--cf-border);
  background: var(--cf-surface);
  color: var(--cf-text-muted);
}
.m182-pill--success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}
.m182-pill--info {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}
.m182-pill--warning {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}
.m182-guia {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  border-radius: 10px;
  padding: 12px 16px;
}
.m182-guia__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #15803d;
}
.m182-guia__head mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.m182-guia__close {
  margin-left: auto;
  border: 0;
  background: none;
  color: #15803d;
  cursor: pointer;
  padding: 0;
}
.m182-guia__pasos {
  margin: 8px 0 10px 0;
  padding-left: 22px;
  font-size: 12.5px;
  color: var(--cf-text);
}
.m182-guia__pasos li {
  margin-bottom: 3px;
}
.m182-presentar {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.m182-presentar__acciones {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.m182-layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  padding-top: 4px;
}
.m182-rail {
  position: sticky;
  top: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.m182-rail__block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m182-rail__label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.m182-rail__buscador {
  display: flex;
  gap: 6px;
  align-items: stretch;
}
.m182-rail__buscador .cf-btn {
  white-space: nowrap;
  flex: 0 0 auto;
  padding: 0 12px;
}
.m182-rail__input {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}
.m182-rail__nota {
  font-size: 11.5px;
  color: var(--cf-text-muted);
  word-break: break-all;
}
.m182-rail__seccion {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 2px;
  padding: 7px 10px;
  border: 0;
  border-radius: 6px;
  background: none;
  font: inherit;
  font-size: 12.5px;
  color: var(--m182-brand-d);
  text-align: left;
  cursor: pointer;
}
.m182-rail__seccion-texto {
  flex: 1 1 auto;
}
.m182-rail__seccion-numero {
  font-weight: 700;
}
.m182-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m182-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
}
.m182-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--m182-muted);
}
.m182-atribuciones {
  overflow-x: auto;
}
.m182-tabla-simple {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.m182-tabla-simple th,
.m182-tabla-simple td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--m182-border);
  color: var(--m182-text);
  text-align: left;
}
.m182-tabla-simple th {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--m182-muted);
  background: #f9fafb;
}
.m182-tabla-simple .m182-num {
  text-align: right;
  white-space: nowrap;
}
.m182-vacio {
  text-align: center !important;
  color: var(--m182-muted) !important;
  padding: 18px 10px !important;
}
@media (max-width: 992px) {
  .m182-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .m182-rail {
    position: static;
  }
}
@media (max-width: 768px) {
  .m182-page {
    padding: 16px;
  }
  .m182-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .m182-actions .cf-btn {
    width: 100%;
  }
  .m182-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .m182-field {
    grid-column: span 1 !important;
  }
}
.m182-card {
  background: var(--m182-surface);
  border: 1px solid var(--m182-border);
  border-radius: var(--m182-radius);
  box-shadow: var(--m182-shadow);
  overflow: hidden;
}
.m182-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--m182-brand);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.m182-card__chevron {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--m182-brand-d);
  opacity: .75;
  flex: 0 0 auto;
}
.m182-card--collapsed > *:not(.m182-card__head) {
  display: none;
}
.m182-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m182-brand-d);
  opacity: .9;
}
.m182-card__head-label {
  flex: 1 1 auto;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--m182-brand-d);
}
.m182-card__body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m182-card__check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m182-brand-d);
  flex: 0 0 auto;
}
.m182-card__foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 12px;
}
.m182-card:not(.m182-card--collapsed) > *:not(.m182-card__head) {
  animation: m182-reveal .2s ease;
}
@keyframes m182-reveal {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 480px) {
  .m182-card__body {
    padding: 12px;
  }
}
.m182-rail__seccion:hover {
  background: rgba(227, 253, 100, .3);
}
.m182-rail__seccion--activa {
  background: var(--m182-brand);
  color: var(--m182-brand-d);
  font-weight: 600;
}
.m182-rail__seccion-check {
  color: var(--m182-brand-d);
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.m182-rail__seccion-hueco {
  width: 14px;
  height: 14px;
  border: 1px solid var(--m182-border);
  border-radius: 3px;
  flex: 0 0 auto;
}
/*# sourceMappingURL=model-182.component.css.map */
